module.exports = new __parcel__URL__("jpd-prioritization-roadmap-dark.54413b95.svg").toString();